import type { UserInformation } from '@rover/rsdk/src/apiClient/latest/model/userInformation';

export default function userFactory(opts?: Partial<UserInformation>): UserInformation {
  return {
    opk: '',
    apiUrl: '',
    email: '',
    emailHash: '',
    emailHashSha256: '',
    firstName: '',
    lastName: '',
    phone: '',
    address: null,
    isStaff: false,
    postalCode: '',
    hasDogs: false,
    isActiveServiceProvider: false,
    listsAllServices: false,
    shouldPromptForPets: false,
    slug: '',
    providerGroupSlug: '',
    smallPhotoUrl: '',
    timeZone: '',
    unreadMessageCount: 0,
    showAdminToolbar: false,
    isNewCustomer: false,
    isSsuMigrated: false,
    isIdentityVerificationRequired: false,
    isActiveSssuApplicantWithSelectedServices: false,
    isAnApprovedProvider: false,
    wasEverServiceProvider: false,
    userMode: '',
    isBrightHorizonsUser: false,
    weightUnit: '',
    shouldShowUserHome: false,
    shouldShowContactsTab: false,
    hasSitterIntent: false,
    isRoverlapper: false,
    isCmsMigrated: false,
    ...opts,
  };
}
